// Utility function to make authenticated API calls using HTTP Basic Auth
export async function fetchWithAuth(url: string, options?: RequestInit): Promise<Response> {
  // Get stored credentials from localStorage
  const authData = localStorage.getItem('auth_credentials')
  
  if (!authData) {
    // Redirect to login if no credentials stored
    window.location.href = '/login.html'
    throw new Error('No authentication credentials found')
  }

  const { username, password } = JSON.parse(authData)
  const credentials = btoa(`${username}:${password}`)

  const authOptions = {
    ...options,
    headers: {
      ...options?.headers,
      'Authorization': `Basic ${credentials}`
    }
  }

  const response = await fetch(url, authOptions)

  // If unauthorized, clear credentials and redirect to login
  if (response.status === 401) {
    localStorage.removeItem('auth_credentials')
    window.location.href = '/login.html'
  }

  return response
}

// Login function to store credentials
export function login(username: string, password: string): void {
  localStorage.setItem('auth_credentials', JSON.stringify({ username, password }))
}

// Logout function to clear credentials
export function logout(): void {
  localStorage.removeItem('auth_credentials')
  window.location.href = '/login.html'
}

// Check if user is logged in
export function isLoggedIn(): boolean {
  return localStorage.getItem('auth_credentials') !== null
}